<template>
    <div>
        <Hero :left="true" title="Contact us" :highlight-words="['contact']" subtitle="Unified.to powers integrations for AI and SaaS products with real-time unified data. Reach out to see how we can support your integration needs.
" />

        <div class="px-3 sm:px-16 pb-16 -mt-6">
            <Benefits :benefits="OPTIONS" />
        </div>

        <section class="w-full px-3 sm:px-28">
            <h3>Have a different question?</h3>
            <p class="box-description mt-4">
                If your inquiry isn't related to support, documentation, or sales demos, send us a message below.
            </p>

        </section>

        <div class="snap-center mx-auto sm:mt-04 rounded sm:py-4 px-3 sm:px-28 text-light-gray">
            <iframe :src="`https://tally.so/embed/w2o9pn?alignLeft=1&hideTitle=1&v=2${more}`" width="100%"
                class="h-[1800px] sm:h-[1200px]" frameborder="0" marginheight="0" marginwidth="0" title="Contact Form">
            </iframe>
        </div>
    </div>
</template>

<script lang="ts">
import { setTitle } from '~~/services/common';

export default {

    setup() {
        setTitle(
            'Contact',
            'Our Unified API helps developers add integrations faster, so SaaS companies can make better products and grow their revenue. Talk to our sales team today about your use cases and integrations goals. Get a demo.'
        );
        return {
            OPTIONS: [
                {
                    title: 'Product Support',
                    body: 'Get live support in our Discord community. Customers get private channels for dedicated support and ticketing.',
                    button_text: 'Get support',
                    button_link: 'https://discord.gg/85z7HF7JbD'
                },
                {
                    title: 'Documentation',
                    body: 'Review our tutorials, how-to guides, troubleshooting articles, and API reference.',
                    button_text: 'View docs',
                    button_link: 'https://docs.unified.to'
                },
                {
                    title: 'Talk to Sales',
                    body: "Tell us what you're building and see how Unified works with your stack.",
                    button_text: 'Book a demo',
                    button_link: '/book-a-demo'
                }
            ]
        }
    },
    data() {
        return {
            more: '',
        };
    },
    mounted() {
        const integration = this.$route.query?.i;
        const cat = this.$route.query?.c;
        console.log('integration', integration, cat);
        if (integration && cat) {
            this.more =
                '&category=' +
                encodeURIComponent(cat as string).toUpperCase() +
                '&howhelp=' +
                encodeURIComponent('I have a Product Feature Request') +
                '&comment=I need a ' +
                integration +
                ' integration.';
        }
    },
};
</script>